<div class="dropdown-container">
  <!-- Header styled like Bootstrap form-select -->
  <div class="form-select" (click)="toggleDropdown()">
    <span>
      {{ selectedValues.length ? selectedValues.join(', ') : placeholder }}
    </span>
  </div>

  <!-- Dropdown list -->
  <div class="dropdown-menu show w-100 mt-1" *ngIf="isOpen">
    <button class="dropdown-item" *ngFor="let option of options" (click)="toggleSelection(option.value)">
      <input type="checkbox" [checked]="isSelected(option.value)" class="me-2" />
      {{ option.key | titlecase }}
    </button>
  </div>
</div>
